module.exports = __webpack_public_path__ + "static/media/Plus.5cbb64bb.svg";